import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { fetchApiWithAllFilters } from "../api"
import { getCategories, setCategories } from "../category"
import { getFilters, isAnyFilterActive, setFilters } from "../filter"
import { updateFilterCategoryCheckboxes } from "./category-checkboxes"
import { updateFilterCheckboxes } from "./filter-checkboxes"
import { updateFilterTabsInDomMobile } from "./filter-tabs"

export const getFilterClearButton = () => document.querySelector<HTMLButtonElement>("#clean-filter-options-button")

getFilterClearButton()?.addEventListener("click", async () => {
    if (!isAnyFilterActive()) {
        return
    }
    setFilters({})
    setCategories([])
    updateFilterCategoryCheckboxes(getCategories())
    updateFilterCheckboxes(getFilters())
    updateFilterTabsInDomMobile()
    const result = await fetchApiWithAllFilters()
    afterFilterApiFetched(result)
})
